type MakeCsvOptions<T extends Record<string, any>> = {
    /**
     * A list of entries where the keys pertain to properties
     * in each object, and the values pertain to the header values
     * to be displayed in the CSV file.
     */
    order: [keyof T, string][];
};

const createLine = (values: any[]) => {
    return `${values.map((value) => (value ? `"${value}"` : '-')).join(',')}\n`;
};

const getOrderedColumns = <T>(order: [keyof T, string][], columns: (keyof T)[]) => {
    const columnOrdered = order.reduce((acc: [keyof T, string][], curr) => {
        const [key] = curr;
        if (columns.includes(key)) return [...acc, curr];
        return acc;
    }, []);

    return columnOrdered;
};

export const createCsvMaker = <T extends Record<string, any>>({ order }: MakeCsvOptions<T>) => {
    return ({ items, columns, headers = true }: { items: T[]; columns: (keyof T)[]; headers?: boolean }) => {
        const orderedColumns = getOrderedColumns(order, columns);

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const headerLine = orderedColumns.map(([_, header]) => header);

        const init = headers ? createLine(headerLine) : '';

        return items.reduce((acc, item) => {
            return acc + createLine(orderedColumns.map(([key]) => item[key]));
        }, init);
    };
};

export const getCells = (csv: string) =>
    csv
        .trim()
        // ? Remove top line, trailing commas, and spaces
        .replace(/(^.+\r?\n)|,$|( )+/g, '')
        .split(/[,\r\n]+/g);
